<div class="new-open-chart">
  <div class="card-custom p-4">
    <h2 class="chart-title">Báo cáo mở mới</h2>
    <div class="d-flex justify-content-between">
      <div class="dropdown">
        <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{selected?.type}}
        </button>
        <ul class="dropdown-menu">
            <li *ngFor="let item of option">
              <a class="dropdown-item" href="#" (click)="selectOption($event, item?.value, item?.type)">
                {{ item?.type }}
              </a>
            </li>
          </ul>
    </div>
      <div *ngIf="this.selected.value !== 'active'" class="group-button d-flex">
        <div class="btn-month" [ngClass]="{ 'active': selected.tab === 'month' }" (click)="setActiveTab($event,'month')">
          Tháng
        </div>
        <div class="btn-day" [ngClass]="{ 'active': selected.tab === 'day' }" (click)="setActiveTab($event,'day')">
          Ngày
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="chart-container" *ngIf="!loading">
      <apx-chart [series]="chartOptions?.series" [chart]="chartOptions?.chart" [plotOptions]="chartOptions?.plotOptions"
        [dataLabels]="chartOptions?.dataLabels" [stroke]="chartOptions?.stroke" [xaxis]="chartOptions?.xaxis"
        [yaxis]="chartOptions?.yaxis" [fill]="chartOptions?.fill" [annotations]="chartOptions?.annotations"
        [tooltip]="chartOptions?.tooltip" [legend]="chartOptions?.legend" [grid]="chartOptions?.grid">
      </apx-chart>
    </div>
  </div>
</div>